import React from "react";
import { PomLastTestResponse } from "../../typings/pom";
import PomLastTest from "./PomLastTest";
import { Card } from "../UI/Card";
import Button from "../UI/Button";
import { Play, Sparkles } from "lucide-react";

interface PomTestIntroProps {
  loading: boolean;
  lastTest: PomLastTestResponse | null;
  onStartTest: () => void;
  onViewLastTestDetail: () => void;
}

const PomTestIntro: React.FC<PomTestIntroProps> = ({
  loading,
  lastTest,
  onStartTest,
  onViewLastTestDetail,
}) => {
  return (
    <div className="riasec-container p-3">
      <div className="w-full">
        <div className="flex flex-wrap">
          <div className="w-full">
            <h5 className="text-2xl font-bold mb-4 text-center text-foreground">
              Kelase PersonaDNA
            </h5>
            <Card className="p-6 border-indigo-100 shadow-md">
              <div className="flex items-center gap-3 mb-4 text-primary">
                <Sparkles className="w-6 h-6" />
                <h6 className="font-bold text-lg">Kenali Potensi Diri Anda</h6>
              </div>

              <p className="text-gray-700 text-justify mb-4 leading-relaxed">
                Kelase PersonaDNA atau Personality Orientation Mapping (POM)
                adalah instrumen asesmen berbasis self-assessment yang dirancang
                untuk mengidentifikasi kecenderungan orientasi individu dalam
                berinteraksi, memproses informasi, mengambil keputusan, dan
                mengelola aktivitas. Hasil asesmen digunakan untuk mendukung
                pemetaan potensi, perencanaan pengembangan kompetensi, serta
                rekomendasi jalur belajar dan karier yang lebih personal..
              </p>

              <div className="p-4 rounded-xl border bg-indigo-50 border-indigo-100 text-indigo-900 space-y-3">
                <div className="font-bold border-b border-indigo-200 pb-1">
                  Petunjuk Pengisian:
                </div>
                <ul className="space-y-2 list-disc list-outside pl-4 text-sm">
                  <li>
                    Terdapat <strong>48 pernyataan</strong> singkat.
                  </li>
                  <li>
                    Jawablah secara spontan berdasarkan apa yang{" "}
                    <strong>paling sering</strong> Anda rasakan atau lakukan.
                  </li>
                  <li>
                    Pilih pilihan jawaban yang <strong>paling sesuai</strong>{" "}
                    dengan diri Anda.
                  </li>
                  <li>
                    Tidak ada jawaban yang benar atau salah, semua jawaban
                    adalah unik sesuai diri Anda.
                  </li>
                </ul>
              </div>

              <div className="w-full flex justify-center mt-8">
                <Button
                  primary
                  block
                  className="gradient-primary hover:gradient-primary/90 text-lg font-bold py-6 rounded-xl shadow-lg transition-transform active:scale-95"
                  onClick={onStartTest}
                  disabled={loading}
                >
                  <Play className="fill-current" />{" "}
                  {loading ? "Memuat..." : "Mulai Tes"}
                </Button>
              </div>
            </Card>

            {lastTest && (
              <div className="mt-8">
                <PomLastTest
                  lastTest={lastTest}
                  onViewDetail={onViewLastTestDetail}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PomTestIntro;
